import { Children, cloneElement } from 'react';

import { useInterviewsPutQueryById } from '../../../../Common/Queries/interviewsQueries';
import { useNotesPostQuery } from '../../../../Common/Queries/notesQueries.tsx';

export const NotesEditorContainer = ({ children, ...props }) => {
  const putToInterview = useInterviewsPutQueryById();
  const postReplies = useNotesPostQuery();
  const child = Children.only(children);
  return cloneElement(child, { putToInterview, postReplies, ...props });
};
